import {componentStylesAndSkinsAPI} from '@wix/document-services-implementation'
import type {PublicMethodUtils} from '@wix/document-services-types'
import type {ResponsiveStylesPublicAPI} from '@wix/document-services-public-types'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<ResponsiveStylesPublicAPI> {
    return {
        methods: {
            components: {
                style: {
                    getId: publicMethodUtils.defineGetter(componentStylesAndSkinsAPI.style.getId),
                    get: publicMethodUtils.defineGetter(componentStylesAndSkinsAPI.style.get),
                    update: publicMethodUtils.defineDataManipulationAction(componentStylesAndSkinsAPI.style.update),
                    connectToTheme: publicMethodUtils.defineDataManipulationAction(
                        componentStylesAndSkinsAPI.style.connectToThemeStyle
                    ),
                    scoped: {
                        remove: publicMethodUtils.defineDataManipulationAction(
                            componentStylesAndSkinsAPI.style.removeScoped
                        )
                    },
                    fork: publicMethodUtils.defineDataManipulationAction(componentStylesAndSkinsAPI.style.fork),
                    isSystemStyle: publicMethodUtils.defineGetter(componentStylesAndSkinsAPI.style.isSystemStyle)
                },
                getColorsListInAllComponents: publicMethodUtils.extensionPublicAPI.getter(
                    'style.getColorsListInAllComponents'
                ),
                replaceColorInAllComponents: publicMethodUtils.extensionPublicAPI.dataManipulation(
                    'style.replaceColorInAllComponents'
                )
            }
        }
    }
}
